import React from 'react'

import { AlertBox } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

import RemoveProjectButton from '../ProjectTools/RemoveProjectButton'

export const AddToCartValidationToast: React.FC<{ projectNumber: number }> = ({ projectNumber }) => {
  const { t } = useLocalizations()
  const testId = `atc-validation-toast-${projectNumber}`

  return (
    <AlertBox skin="error" data-testid={testId}>
      {formatAddToCartValidationMessage(t('alert-messages.invalid-qty-for-add-to-cart.value'), projectNumber)}
    </AlertBox>
  )
}

function formatAddToCartValidationMessage(alertMessage: string, projectNumber: number) {
  const splitMessage = alertMessage.split('{remove_link}')
  return [splitMessage[0], <RemoveProjectButton key={projectNumber} useLowerCase={true} />, splitMessage[1]]
}
